import { Button } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { Scope } from '../../../../../../enums/scope'
import { useSegment } from '../../../../../../hooks'
import { isAuthorized } from '../../../../../../utils/isAuthorized'
import { useTransactionsEmberConnection } from '../../../../contexts/transactionsEmberConnectionContext'

export const TransactionsSideActions = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { handleAddTransaction } = useTransactionsEmberConnection()

  const shouldHideAddTransaction = !isAuthorized(Scope.TransactionWrite, false, true)

  const handleAddTransactionClick = useCallback(() => {
    track('xxx - Bookkeeping - Ledger - Side actions', { action: 'Add transaction' })
    handleAddTransaction()
  }, [handleAddTransaction, track])

  if (shouldHideAddTransaction) {
    return <></>
  }

  return (
    <Button icon="circlePlus" onClick={handleAddTransactionClick}>
      {t('transactions.side_actions.new')}
    </Button>
  )
}
